import {parse, URIComponents} from 'uri-js';

/**
 * Checks if the URI is an SVG.
 */
export const isSvg = (value: string): boolean => {
  try {
    // Parse
    const uri: URIComponents = parse(value);

    // Return
    return (uri?.path || value).toLocaleLowerCase().endsWith('.svg') ? true : false;
  } catch (error) {
    // Ops. We have an error.
    // Let's do a more simplistic verification.
    return value.toLocaleLowerCase().endsWith('.svg') ? true : false;
  }
};
